// VIN: 17 chars, latin letters + digits, excluding I, O, Q.
const VIN_RE = /^[A-HJ-NPR-Z0-9]{17}$/;

export function normalizeVin(v) {
  return (v || "").replace(/\s+/g, "").toUpperCase();
}

// Valid if empty (optional) or a well-formed 17-char VIN.
export function isValidVin(v) {
  const s = normalizeVin(v);
  if (!s || s === "-") return true;
  return VIN_RE.test(s);
}

export const VIN_HINT = "VIN — 17 символов (латиница и цифры, без I, O, Q).";
